import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

import { NewEmailBeingSentStyles } from '@/components/emailWindow/styles/NewEmail.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

interface Props {
  isSending: boolean;
}

export const NewEmailBeingSent: React.FC<Props> = props => {
  const { isSending } = props;

  if (!isSending) {
    return null;
  }

  return (
    <>
      <Box sx={NewEmailBeingSentStyles}>
        <CircularProgress sx={{ color: themeColors.accentColor }} />
      </Box>
    </>
  );
};
